import React from "react";
import {Edit} from "react-admin";
import NoopComponent from "common/noop-component/NoopComponent";
import AnnouncementForm from "./AnnouncementForm";

export default (props) => {
  return <Edit {...props} title={<NoopComponent/>} hasShow={false}>
    <AnnouncementForm action='edit'/>
  </Edit>
};